import React, { useRef, useState } from 'react'
import { Box, H2 } from '../layout'
import { Bullets } from '../pricing'
import { assetUrl } from '../../utilities'
import { Dialog, Icon } from '../widgets'
import './StopSurveying.css'

export const StopSurveying = () => {
  const videoRef = useRef()
  const [open, setOpen] = useState(false)
  const videoControl = () => {
    setOpen(!open)
    if(open) {
      videoRef.current.pause()
    } else {
      videoRef.current.play()
    }
  }

  return (
    <Box
      className="stop-survey-container"
      gap={80}
      alignItems="center"
      justifyContent="center"
      fullWidth
    >
      <Box
        rotate={3}
        className="image"
        r={26}
        border="1px solid white"
        shadow="2px 2px 0px 0px white"
        overflow="hidden"
        justifyContent="center"
        alignItems="center"
        cursor="pointer"
        onClick={videoControl}
      >
        <img alt="team" src={assetUrl(`team.png`)} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        <Box position="absolute" zIndex={2}>
          <Icon icon="Play" size={60} />
        </Box>
      </Box>
      <Box gap={32} column>
        <H2 align="left">Stop surveying teams.<br/>Start developing them.</H2>
        <Box column gap={16}>
          <Bullets
            tickColor="white"
            backgroundColor="blue"
            items={['No surveys. No delays. No static reports', 'Built for teams, not individuals', 'Continuous development, not one-off insight']}
          />
        </Box>
      </Box>

      <Dialog open={open} onClose={videoControl}>
        <video
          controls
          ref={videoRef}
          src={assetUrl('tutorial-standard-notimer.mp4', 'videos')}
          style={{ height: '100dvh' }}
        />
      </Dialog>
    </Box>
  )
}